export const tasks_sorting = [
  {
    label: "Title",
    value: "title:asc",
  },
  {
    label: "Title",
    value: "title:desc",
  },
  {
    label: "Status",
    value: "status:asc",
  },
  {
    label: "Status",
    value: "status:desc",
  },
  {
    label: "Priority",
    value: "priority:asc",
  },
  {
    label: "Priority",
    value: "priority:desc",
  },
  {
    label: "Work time",
    value: "time_tracked:asc",
  },
  {
    label: "Work time",
    value: "time_tracked:desc",
  },
  {
    label: "Due date [ALT]",
    value: "due_date:asc",
  },
  {
    label: "Due date [ALT]",
    value: "due_date:desc",
  },
  {
    label: "Creation date",
    value: "created_at:asc",
  },
  {
    label: "Creation date",
    value: "created_at:desc",
  },
  {
    label: "Website [SHORT]",
    value: "website:asc",
  },
  {
    label: "Website [SHORT]",
    value: "website:desc",
  },
];
